export default {
  namespaced: true,
  layout_builder: {
    title: 'Layouts',
    action_add: 'Create layout',
    action_update: 'Update layout',
    fields: {
      name: {
        label: 'Layout Name',
        placeholder: 'Layout Name'
      },
      tenant: {
        label: 'Tenant',
        placeholder: 'Tenant'
      },
      users: {
        label: 'Users',
        placeholder: 'Users'
      },
      default: {
        label: 'Default',
      },
      card: {
        label: 'Card',
      },
      card_distance: {
        label: 'Distance',
      },
      update_current: {
        label: 'Update layout',
      },
      create_new_layout: {
        label: 'Create new layout',
      },
      dashboard_mode: {
        label: 'Dashboard mode',
      },
    },
    btns: {
      add_slot: 'Add slot',
      save: 'Save',
    },
    strings: {
      optional: 'Optional',
    },
    messages: {
      no_blank_spaces: 'No blank spaces',
      no_enough_space: 'Not enough space for a new item',
      created_success: 'Layout created successfully',
      updated_success: 'Layout updated successfully',
      new_layout_created: 'New layout created',
    },
    is_default: 'Default',
    preview: 'Preview',
  }
}
